import { AppConfig } from '../models/app-config.interface';

/**
 * Resolve a rota de destino após login bem-sucedido ou quando usuário
 * autenticado acessa /login.
 *
 * - nomoh-cliente → minha-conta (portal de acesso aos sistemas)
 * - demais apps → dashboardRoute configurado no AppConfig
 */
export function resolvePostLoginRoute(
  appConfig: AppConfig | undefined,
  userId?: string
): (string | number)[] {
  if (appConfig?.app === 'nomoh-cliente' && userId) {
    return ['/minha-conta', userId];
  }

  if (appConfig?.dashboardRoute) {
    return [appConfig.dashboardRoute];
  }

  return userId ? ['/minha-conta', userId] : ['/'];
}
